import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AuthContext from "../../store/AuthContext";
import { MemberOnlyTabs, TabRoutes, TabType } from "../../Enums/EventEnums";
import { setPrevPathForRedirectAfterLogin } from "../../utils/logout";

export const EventTabGuard = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);

  const eventPathPattern = /^\/events\/[^/]+\/([^/]+)/;
  const match = location.pathname.match(eventPathPattern);

  if (!match || !match[1]) {
    return <>{children}</>;
  }

  const routeSegment = match[1];

  const isRegistrationChild =
    routeSegment === "form" ||
    routeSegment === "payment" ||
    routeSegment === "success";
  const tabRoute = isRegistrationChild ? "registration" : routeSegment;

  const tabType = Object.entries(TabRoutes).find(
    ([_, route]) => route === tabRoute
  )?.[0] as TabType | undefined;

  if (!tabType) {
    return <>{children}</>;
  }

  if (MemberOnlyTabs.includes(tabType) && !isAuthenticated) {
    const fullPath = location.pathname + (location.search || "");
    setPrevPathForRedirectAfterLogin(fullPath);
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
};
